import { render, staticRenderFns } from "./RecordLog.vue?vue&type=template&id=509004cc"
import script from "./RecordLog.vue?vue&type=script&lang=js"
export * from "./RecordLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports